import { DIALOG_DATA } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { ButtonComponent } from '@app/components/button/button.component';
import { DialogBase } from '@app/components/dialog/dialog-base';
import { VariantType2 } from '@app/enums/variant-type-2';
import { CurrencyInfo } from '@app/models/currency-info';
import { GameCurrencyPipe } from '@app/pipes/game-currency.pipe';
import { Table } from '@app/store/features/tables/tables.reducer';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-game-dialog-mix-table-details',
  standalone: true,
  imports: [CommonModule, TranslateModule, GameCurrencyPipe, ButtonComponent, AngularSvgIconModule],
  templateUrl: './game-dialog-mix-table-details.component.html',
  styleUrl: './game-dialog-mix-table-details.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: { class: 'dialog app-game-dialog-mix-table-details' }
})
export class GameDialogMixTableDetailsComponent extends DialogBase {
  VariantType2 = VariantType2
  table: Table;
  selectedCurrency: CurrencyInfo;
  constructor(@Inject(DIALOG_DATA) public data: { table: Table, currency: CurrencyInfo }) {
    super()
    this.table = data.table;
    this.selectedCurrency = data.currency;
  }
}
